import {
  ACADEMY_COURSE_CATALOGS,
  catalogCourseEntries,
} from '../content/academyCourses';

const digitalEntries = () => catalogCourseEntries(ACADEMY_COURSE_CATALOGS.digital);

function purchaseMatchesCourse(purchase, course) {
  const num = Number(purchase?.courseNumber) || 0;
  const title = String(purchase?.courseName || '').trim();
  if (num > 0 && Number(course.courseNumber) === num) return true;
  if (title && title === String(course.title || '').trim()) return true;
  return false;
}

export function userOwnsDigitalCourse(course, purchasedCourses = []) {
  if (!course) return false;
  const purchases = Array.isArray(purchasedCourses) ? purchasedCourses : [];
  return purchases.some((purchase) => purchaseMatchesCourse(purchase, course));
}

export function partitionDigitalCoursesForUser(purchasedCourses = []) {
  const purchases = Array.isArray(purchasedCourses) ? purchasedCourses : [];
  const entries = digitalEntries();
  const matchedPurchaseKeys = new Set();

  const owned = [];
  for (const entry of entries) {
    const purchase = purchases.find((p) => purchaseMatchesCourse(p, entry.course));
    if (purchase) {
      matchedPurchaseKeys.add(`${purchase.courseNumber}:${purchase.courseName}`);
      owned.push({ ...entry, purchase });
    }
  }

  for (const purchase of purchases) {
    const key = `${purchase.courseNumber}:${purchase.courseName}`;
    if (matchedPurchaseKeys.has(key)) continue;
    const title = String(purchase.courseName || '').trim() || `קורס ${purchase.courseNumber || ''}`.trim();
    owned.push({
      course: {
        id: `owned-${purchase.courseNumber || title}`,
        title,
        summary: 'הקורס זמין לכם באזור האישי.',
        price: '',
      },
      locked: false,
      purchase,
      orphan: true,
    });
    matchedPurchaseKeys.add(key);
  }

  const discover = entries.filter(
    (entry) => !purchases.some((p) => purchaseMatchesCourse(p, entry.course)),
  );

  return { owned, discover };
}
